import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Loader from "../../../../shared/loader/Loader";
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import Overview from "../Overview/Overview";
import { SUCCESS } from "../../../../../constants/AppConstants";

const DeviceAndDeviceUsageDetails = (props) => {
    const { t } = useTranslation(["CSAgenttranslation"]);
    const TABS = {
        'ZERO_ACTIVE_DEVICES': 'ZERO_ACTIVE_DEVICES',
        "INACTIVE_DEVICES": 'INACTIVE_DEVICES'
    }
    const deviceAndUsageDetailsResponse = useSelector((state) => state.CSAGENT.DeviceAndDeviceUsageDetails);

    const [activeTab, setActiveTab] = useState(
        (deviceAndUsageDetailsResponse?.deviceInfo?.activeDevices?.length > 0)
            ? deviceAndUsageDetailsResponse?.deviceInfo?.activeDevices[0].deviceId
            : null);

    useEffect(() => {
        if (deviceAndUsageDetailsResponse?.deviceInfo
            && deviceAndUsageDetailsResponse?.deviceInfo?.actionStatus?.toUpperCase() === SUCCESS) {
            if (deviceAndUsageDetailsResponse?.deviceInfo?.activeDevices?.length > 0) {
                setActiveTab(deviceAndUsageDetailsResponse?.deviceInfo?.activeDevices[0].deviceId)
            } else {
                setActiveTab(TABS.ZERO_ACTIVE_DEVICES);
            }
        }
    }, [TABS.ZERO_ACTIVE_DEVICES, deviceAndUsageDetailsResponse?.deviceInfo]);

    if (deviceAndUsageDetailsResponse.loading) {
        return <Loader />;
    }

    if (deviceAndUsageDetailsResponse.error) {
        return <div className="email-log-error">{t("ERROR_MESSAGES.DEVICE_NOT_FOUND")}</div>;
    }

    return (
        <div className="device-info-wrapper mt-40">
            <div className="tab-btn-wrapper">
                <div>
                    <Nav tabs>
                        {(deviceAndUsageDetailsResponse?.deviceInfo?.activeDevices?.length > 0) ?
                            deviceAndUsageDetailsResponse?.deviceInfo?.activeDevices.map((device) => (
                                <NavItem>
                                    <NavLink active={activeTab === device.deviceId} onClick={() => setActiveTab(device.deviceId)}>
                                        {device.serialNumber}
                                    </NavLink>
                                </NavItem>
                            )) :
                            <NavItem>
                                <NavLink active={activeTab === TABS.ZERO_ACTIVE_DEVICES} onClick={() => setActiveTab(TABS.ZERO_ACTIVE_DEVICES)}>
                                    {t('CUSTOMER_DASHBOARD.DEVICE_AND_USAGE_DETAILS.ACTIVE_DEVICES')}
                                </NavLink>
                            </NavItem>
                        }
                        <NavItem>
                            <NavLink active={activeTab === TABS.INACTIVE_DEVICES} onClick={() => setActiveTab(TABS.INACTIVE_DEVICES)}>
                                {t('CUSTOMER_DASHBOARD.DEVICE_AND_USAGE_DETAILS.INACTIVE_DEVICES')}
                            </NavLink>
                        </NavItem>
                    </Nav>
                </div>
            </div>
            <div className="device-info-tab-contens">
                <TabContent activeTab={activeTab}>
                    {
                        (deviceAndUsageDetailsResponse?.deviceInfo?.activeDevices?.length > 0) ?
                            deviceAndUsageDetailsResponse?.deviceInfo?.activeDevices.map((device) => (
                                <TabPane tabId={device.deviceId}>
                                    <Overview userData={props?.customerInfo} deviceData={device} fetchCSAgentTabContents={props?.fetchCSAgentTabContents} />
                                </TabPane>
                            )) :
                            <TabPane tabId={TABS.ZERO_ACTIVE_DEVICES}>
                                <div className="email-log-error">{t("CUSTOMER_DASHBOARD.DEVICE_AND_USAGE_DETAILS.NO_ACTIVE_DEVICES")}</div>
                            </TabPane>
                    }
                    <TabPane tabId={TABS.INACTIVE_DEVICES}>
                        <div className="device-usage-details">
                            {(deviceAndUsageDetailsResponse?.deviceInfo?.inactiveDevices?.length > 0) ? (
                                <div className="inactive-devices">
                                    {deviceAndUsageDetailsResponse?.deviceInfo?.inactiveDevices.map((device, index) => (
                                        <div key={index}>
                                            <p>{t("CUSTOMER_DASHBOARD.DEVICE_AND_USAGE_DETAILS.DEVICE_ID")}: <span>{device.deviceId}</span></p>
                                            <p>{t("CUSTOMER_DASHBOARD.DEVICE_AND_USAGE_DETAILS.SERIAL_NUMBER")}: <span>{device.serialNumber}</span></p>
                                            <p>{t("CUSTOMER_DASHBOARD.DEVICE_AND_USAGE_DETAILS.MODEL_NUMBER")}: <span>{device.modelNumber}</span></p>
                                            <hr />
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="email-log-error">{t("CUSTOMER_DASHBOARD.DEVICE_AND_USAGE_DETAILS.NO_INACTIVE_DEVICES")}</div>
                            )}
                        </div>
                    </TabPane>
                </TabContent>
            </div>
        </div>
    );
};

export default DeviceAndDeviceUsageDetails;
